import { SectionHeader } from "./SectionHeader";
import useReveal from "@/lib/useReveal";
import { useSection } from "@/lib/SiteContent";
import { imageUrl } from "@/lib/api";

const DEFAULT_IMG =
  "https://images.unsplash.com/photo-1618844035942-1178d8a34ff3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxjb3VwbGUlMjBzdGFuZGluZyUyMGJ5JTIwdGhlJTIwc2VhJTIwbWluaW1hbGlzdCUyMG5ldXRyYWx8ZW58MHx8fHwxNzc4NDI3OTY4fDA&ixlib=rb-4.1.0&q=85";

const FALLBACK = {
  quote: "«Det begynte med en samtale som aldri tok slutt — og fortsetter fortsatt, hver dag.»",
  paragraphs: [],
  caption: "— Sommeren begynte ved sjøen",
  image_id: null,
};

export const OurStory = () => {
  const story = useSection("story", FALLBACK);
  const img = story.image_id ? imageUrl(story.image_id) : DEFAULT_IMG;
  const refImg = useReveal();
  const refText = useReveal();

  return (
    <section
      id="historie"
      data-testid="story-section"
      className="py-24 md:py-40 px-6 md:px-12 lg:px-24 bg-[#F3F5E7]"
    >
      <div className="max-w-7xl mx-auto">
        <SectionHeader eyebrow="Kapittel I" title="Velkommen" testId="story" />
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          <div ref={refImg} className="reveal lg:col-span-5">
            <div className="img-zoom aspect-[4/5]">
              <img src={img} alt="Celine og Aleksander" className="w-full h-full object-cover" loading="lazy" />
            </div>
            <p className="text-xs uppercase tracking-[0.3em] text-[#68919B] mt-4">{story.caption}</p>
          </div>
          <div ref={refText} className="reveal lg:col-span-7 lg:pl-8">
            <p className="font-serif italic text-2xl md:text-3xl text-[#3D5E68] leading-relaxed mb-10">
              {story.quote}
            </p>
            <div className="space-y-6 text-[#5A7682] font-light text-base md:text-lg leading-relaxed">
              {(story.paragraphs || []).map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
            <div className="mt-12 flex items-center gap-4">
              <span className="ornament" />
              <p className="font-serif italic text-lg text-[#68919B]">Celine &amp; Aleksander</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
